module.exports = __webpack_public_path__ + "assets/comfirm-purple.a1782f4d.svg";